const isElementInViewport = (el, divide = 3) => {
    // Special bonus for those using jQuery
    if (el) {
        let rect = el.getBoundingClientRect();
        let bottom = 0;
        if (divide === 1) {
            bottom = (window.innerHeight || document.documentElement.clientHeight)
        } else {
            bottom = (window.innerHeight - (window.innerHeight / divide)) || (document.documentElement.clientHeight - (document.documentElement.clientHeight / divide))
        }
        /* if (el.classList.contains('enterLeft')) {
            console.log(el.classList.value)
            console.log('rect.top', rect.top)
            console.log('rect.left', rect.left)
            console.log('rect.bottom', rect.bottom)
            console.log('rect.right', rect.right)
            console.log('window.innerHeight', bottom)
            console.log('window.innerWidth', window.innerWidth)
            console.log('------------------------')
        } */
        return (
            rect.top >= 0 &&
            /* rect.left >= 0 && */
            rect.bottom <= bottom /* && or $(window).height() */
            /* rect.right <= (window.innerWidth || document.documentElement.clientWidth) */ /* or $(window).width() */
        );
    }
    return false;
}

window.addEventListener('scroll', function () {
    let animLeft = document.querySelectorAll(".enterLeft:not(.active)");
    let animRight = document.querySelectorAll(".enterRight:not(.active)");
    let animationsActivate = [...animLeft, ...animRight]
  
    if (animationsActivate.length > 0) {
        animationsActivate.forEach((item) => {
            if (isElementInViewport(item, 1)) {
                item.classList.add('active')
            }
           
        })
    }
});

document.addEventListener("DOMContentLoaded", (event) => {
    let animLeft = document.querySelectorAll(".enterLeft:not(.active)");
    let animRight = document.querySelectorAll(".enterRight:not(.active)");
    let animationsActivate = [...animLeft, ...animRight]
    if (animationsActivate.length > 0) {
        animationsActivate.forEach((item) => {
            if (isElementInViewport(item, 1)) {
                item.classList.add('active')
            }
           
        })
    }
});